import { ConfigModal } from "../Models";

export const config: ConfigModal = {
  baseApi: "https://multimatch.haifa-group.com",
  // baseApi: "http://31.154.36.107:4200/",
  useMockData: false,
  isDebug: false,
  productPlaceHolderImage: "https://via.placeholder.com/80x120",
  cropPlaceHolderImage: "https://via.placeholder.com/56x56",
  googlePlacesApiUrl: "https://maps.googleapis.com/maps/api/geocode/json?language=en&address={0},{1}&key={2}",
  googlePlacesApiKey: "AIzaSyAFFewnU75EiC5R8YDZcocWQxK0BPkLfwY",
  cfpBannerLink: "https://www.haifa-group.com/multimatch-tool-impact-of-controlled-release-fertilizer",
  apiPaths: {
    login: "/api/auth/login",
    logout: "/api/Users/logout",
    register: "/api/auth/register",
    confirmEmail: "/api/auth/confirm-mail",
    resendEmail: "/api/auth/resend-confirmation-mail",
    registrationData: "/api/utils/registration-data",
    homePageData: "/api/utils/home-page-data",
    saveItem: "/api/SavedItems/save-item",
    savedItems: "/api/SavedItems/",
    deleteSavedItems: "/api/SavedItems/delete-item/{0}",
    calculateRecommendedSolutionProduct: "/api/calculation/calculate-recommended-shelf-solution",
    calculateCustomizedSolutionProduct: "/api/calculation/calculate-customized-shelf-solution",
    calculateMulticoteSolutionsResult: "/api/calculation/calculate-multicote-solutions-results",
    forgotPassword: "/api/auth/forgot-password",
    getRawMaterials: "api/Fertilizers/get-raw-materials",
    updateFarmerPractice: "/api/SavedItems/update-farmer-practice/{0}",
    getRawMaterialsBank: "api/Fertilizers/get-raw-materials-by-user",
    deleteRawMaterial: "api/Fertilizers/delete-raw-material/{0}",
    getMulticoteBlends: "api/Fertilizers/get-multicote-blends",
    addRawMaterials: "api/Fertilizers/add-raw-materials",
    changeRecipe: "api/Calculation/change-recipe",
    validatePasswordResetToken: "api/auth/validate-update-password-token",
    updatePassword: "api/auth/update-password",
    share: "api/Utils/share?savedItemId={0}&type={1}",
    updateProfile: "api/users/update-profile",
    getSavedItemById: "api/SavedItems/{0}",
    contactUs: "api/Utils/contact-us",
    duplicateSavedItem: "api/SavedItems/{0}",
    renameSavedItem: "api/SavedItems/rename-item",
    updateLanguage: "api/Users/update-language?ln={0}",
    calculateCFP: "api/CarbonFootprint/calculate?savedItemId={0}",
    checkCalculationStatus: "api/CarbonFootprint/check-status?calculationId={0}",
    collectCrfData: "api/CarbonFootprint/collect-data?calculationId={0}",
    storeCrfData: "api/CarbonFootprint/store-data",
    generatePdf: "api/pdf/generate-pdf",
  },
  imagesPath: "./Images/Products",
  cropImagesPath: "./Images/Crops",
};
